import { ELSDropDown } from '@els/els-component-form-field-react';
import React from 'react';
var DropDown = function (_a) {
    var id = _a.id, name = _a.name, ariaLabel = _a.ariaLabel, changeHandler = _a.changeHandler, options = _a.options, value = _a.value, isDisabled = _a.isDisabled;
    return <ELSDropDown id={id} name={name} ariaLabel={ariaLabel} changeHandler={changeHandler} options={options} value={value} isDisabled={isDisabled}/>;
};
export default DropDown;
